import {FC, useEffect, Suspense} from 'react';

import {PopupLazy} from 'app/modules/popup/lazy';
import {useGemSettingsFeature, useGemSettings} from 'app/utils/config/gemSettingsProvider';
import {getGemSettingsFeature} from 'app/utils/config/getGemSettingsFeature';
import {loadScriptsToDOM} from 'app/utils/initialize/loadScriptsToDOM';
import {loadGroupCMP} from 'app/utils/loadGroupCMP';
import {importGemComponents} from 'gemComponents/importGemComponents';
import {LuxSettingsConfig} from 'interfaces/shared/components/configuration/lux/luxSettingsConfig';
import {PopUpsSettingsConfig} from 'interfaces/shared/popups/popUpsSettingsConfig';

export const GemInitializeOnce: FC = () => {
    const gemSettings = useGemSettings();
    const popupsSettingsConfig = useGemSettingsFeature<PopUpsSettingsConfig>('pop-ups');

    useEffect(() => {
        importGemComponents();
        loadScriptsToDOM(gemSettings);

        if (gemSettings.transitionBackground === 'ENABLED') {
            import(/* webpackChunkName: "backgroundTransitionEffect" */ 'app/modules/backgroundTransitionEffect').then(({setBackgroundTransitionEffect}) =>
                setBackgroundTransitionEffect(),
            );
        }

        const luxSettingsConfig = getGemSettingsFeature<LuxSettingsConfig>(gemSettings, 'lux');
        if (luxSettingsConfig) {
            import('app/modules/lux/initLux').then(({initLux}) => initLux(gemSettings));
        }

        loadGroupCMP(gemSettings);
    }, [gemSettings]);

    if (popupsSettingsConfig) {
        return (
            <Suspense>
                <PopupLazy config={popupsSettingsConfig} />
            </Suspense>
        );
    }
};
